/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CreateMasterAccountResponse {
    getFixupPrototypeFunction() { return CreateMasterAccountResponse.fixupPrototype; }

    static newInstance(model: Partial<CreateMasterAccountResponse>): CreateMasterAccountResponse {
        let obj = Object.assign(new CreateMasterAccountResponse(), model);
        CreateMasterAccountResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CreateMasterAccountResponse>): CreateMasterAccountResponse {
        if (!model) return null;
        return CreateMasterAccountResponse.newInstance(<CreateMasterAccountResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CreateMasterAccountResponse) {
        if (!obj) return;

        models.CreateMasterAccountResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CreateMasterAccountResponse): boolean {
        Object.setPrototypeOf(obj, CreateMasterAccountResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.role_info) {
            models.RoleInfoModel.fixupPrototype(this.role_info);
        }
    }

    /**
     * Account master id
     */
    id: string;

    /**
     * Account master status
     */
    status: string;

    /**
     * Tenant id
     */
    tenant_id: string;

    /**
     * Role info
     */
    role_info: models.RoleInfoModel;

}
